<!--
	@name app-client-dashboard-workflow-conveyancing-get-started
	@description Client Workflow Conveyancing Activity
	@date 2024/02/07
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<v-sheet>
			<v-row>
				<v-col cols="12">
					<video v-if="introResource" class="d-block ml-10 mb-6" :src="introResource.video" :poster="introResource.poster" controls width="50%" style="float: right" />
					<p class="text-body-1 font-weight-bold mb-6">
						Directly referring to a specialist solicitor offers peace of mind in the knowledge that it generally results in a shorter and smoother legal process.
					</p>
					<ul class="text-body-1 pl-8 mb-6">
						<li class="mb-2">
							Direct access to a panel of solicitors who specialise in Later Life Lending conveyancing.
						</li>
						<li class="mb-2">
							Instantly navigate to each of the specialist solicitor's website to obtain pricing and services etc.
						</li>
						<li class="mb-0">
							Referral form available directly for each of the specialist solicitors to speed up the enquiry process.
						</li>
					</ul>
					<p class="text-body-1 mb-8">
						Click on the intro video now to gain a deeper insight into how you can navigate AirFlow's Conveyancing tile and maximise its benefits and features.
					</p>
					<v-btn color="primary" @click="hideGetStartedDisplay">
						Get started
					</v-btn>
					<a class="text-body-2 font-weight-medium d-block mt-4" @click="openChat"> Need more help? Chat with our team. </a>
				</v-col>
			</v-row>
		</v-sheet>
	</div>
</template>

<script>
	import { EventBus } from '@/utils';

	export default {
		name: 'app-client-dashboard-workflow-conveyancing-get-started',

		props: {
			introResource: { type: Object, required: false, default: null }
		},

		created() {
			this.$emit('toggle-intro-resource');
		},

		methods: {
			hideGetStartedDisplay() {
				this.$emit('hideGetStartedDisplay');
				this.$emit('toggle-intro-resource');
			},

			/**
			 * @name openChat
			 */
			openChat: function() {
				EventBus.$emit('open-chat');
			}
		}
	};
</script>
